export default __webpack_public_path__ + "static/media/members.05975261.svg";